import React, { createContext, useState } from "react";

const SimulationContext = createContext({});

export const SimulationProvider = ({ value, children }) => {
    const initState = ((process.env?.NODE_ENV === 'development') && process.env?.REACT_APP_MOCK_SIMSTATE) ? 
        JSON.parse(process.env?.REACT_APP_MOCK_SIMSTATE) :
        {
            allowSlideNext: true,
            currentStep: 0,
            completeSteps: 0,
            validSteps: 1 | (1 << 4),
            location: null,
            consos: [null, null, null],
            infos: null,
            simResults: null
        };
    const [parameters, setParameters] = useState(initState);

    return <SimulationContext.Provider value={[parameters, setParameters]}>{children}</SimulationContext.Provider>;
};

export default SimulationContext;